import styled from "styled-components"

export const Ribbon = styled.div`
  width: 12.1em;
  height: 12.1em;
  position: fixed;
  overflow: hidden;
  top: 0;
  right: 0;
  z-index: 9999;
  pointer-events: none;
  font-size: 13px;
  text-decoration: none;
  text-indent: -999999px;
  cursor: pointer;

  &:before,
  &:after {
    /* The right and left classes determine the side we attach our banner to */
    position: absolute;
    display: block;
    width: 15.38em;
    height: 1.54em;

    top: 3.23em;
    right: -3.23em;

    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;

    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  &:before {
    content: "";

    /* Add a bit of padding to give some substance outside the "stitching" */
    padding: 0.38em 0;

    /* Set the base colour */
    background-color: #e74c3c;

    pointer-events: auto;
  }

  &:after {
    /* Set the text from the data-ribbon attribute */
    content: attr(data-ribbon);

    /* Set the text properties */
    color: #fff;
    font:
      700 1em "Helvetica Neue",
      sans-serif;
    line-height: 1.54em;
    text-decoration: none;
    text-align: center;
    text-indent: 0;

    /* Set the layout properties */
    padding: 0.15em 0;
    margin: 0.15em 0;
  }

  &:hover,
  &:active {
    opacity: 0.5;
  }
`
